import React from 'react';
import { userGrowthData, revenueData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
import { TrendingUp, Users, DollarSign, AlertCircle } from 'lucide-react';
const Business: React.FC = () => {
  return <div className="space-y-6" data-id="element-788">
      <div data-id="element-789">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-790">
          Business Intelligence
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-791">
          Track growth metrics, revenue, and business opportunities.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-792">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-793">
          <div className="flex items-center" data-id="element-794">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-795">
              <Users size={24} data-id="element-796" />
            </div>
            <div className="ml-5" data-id="element-797">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-798">
                User Acquisition
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-799">
                +12.5%
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-800">
                vs. last month
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-801">
          <div className="flex items-center" data-id="element-802">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-803">
              <DollarSign size={24} data-id="element-804" />
            </div>
            <div className="ml-5" data-id="element-805">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-806">
                Monthly Revenue
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-807">
                $45,621
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-808">
                +8.3% vs. last month
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-809">
          <div className="flex items-center" data-id="element-810">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-200" data-id="element-811">
              <AlertCircle size={24} data-id="element-812" />
            </div>
            <div className="ml-5" data-id="element-813">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-814">
                Churn Rate
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-815">
                2.4%
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-816">
                -0.3% vs. last month
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-817">
          <div className="flex items-center" data-id="element-818">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-200" data-id="element-819">
              <TrendingUp size={24} data-id="element-820" />
            </div>
            <div className="ml-5" data-id="element-821">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-822">
                Lifetime Value
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-823">
                $840
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-824">
                +$42 vs. last month
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-825">
        <ChartCard title="User Growth Trend" subtitle="New user registrations over time" data={userGrowthData} type="line" dataKeys={['users']} colors={['#3B82F6']} data-id="element-826" />
        <ChartCard title="Revenue Breakdown" subtitle="Monthly revenue by source" data={revenueData} type="bar" dataKeys={['premium', 'referrals']} colors={['#8B5CF6', '#EC4899']} data-id="element-827" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-828">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-829">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-830">
            Customer Acquisition Cost
          </h3>
          <div className="space-y-4" data-id="element-831">
            <div data-id="element-832">
              <div className="flex justify-between text-sm mb-1" data-id="element-833">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-834">
                  Organic Search
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-835">
                  $12.40
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-836">
                <div className="bg-green-600 h-2.5 rounded-full" style={{
                width: '25%'
              }} data-id="element-837"></div>
              </div>
            </div>
            <div data-id="element-838">
              <div className="flex justify-between text-sm mb-1" data-id="element-839">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-840">
                  Social Media
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-841">
                  $24.80
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-842">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: '50%'
              }} data-id="element-843"></div>
              </div>
            </div>
            <div data-id="element-844">
              <div className="flex justify-between text-sm mb-1" data-id="element-845">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-846">
                  Paid Advertising
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-847">
                  $36.20
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-848">
                <div className="bg-purple-600 h-2.5 rounded-full" style={{
                width: '75%'
              }} data-id="element-849"></div>
              </div>
            </div>
            <div data-id="element-850">
              <div className="flex justify-between text-sm mb-1" data-id="element-851">
                <span className="text-gray-500 dark:text-gray-400" data-id="element-852">
                  Referrals
                </span>
                <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-853">
                  $8.60
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2.5" data-id="element-854">
                <div className="bg-yellow-500 h-2.5 rounded-full" style={{
                width: '15%'
              }} data-id="element-855"></div>
              </div>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700" data-id="element-856">
            <div className="flex justify-between" data-id="element-857">
              <span className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-858">
                Average CAC
              </span>
              <span className="text-sm font-bold text-gray-900 dark:text-white" data-id="element-859">
                $22.45
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-860">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-861">
            Retention Cohorts
          </h3>
          <div className="overflow-x-auto" data-id="element-862">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-863">
              <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-864">
                <tr data-id="element-865">
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-866">
                    Cohort
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-867">
                    Month 1
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-868">
                    Month 3
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-869">
                    Month 6
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-870">
                    Month 12
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-871">
                <tr data-id="element-872">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-873">
                    Jan 2023
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-874">
                    100%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-875">
                    85%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-876">
                    72%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-877">
                    -
                  </td>
                </tr>
                <tr data-id="element-878">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-879">
                    Feb 2023
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-880">
                    100%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-881">
                    88%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-882">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-883">
                    -
                  </td>
                </tr>
                <tr data-id="element-884">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-885">
                    Mar 2023
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-886">
                    100%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-887">
                    90%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-888">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-889">
                    -
                  </td>
                </tr>
                <tr data-id="element-890">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-891">
                    Apr 2023
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-892">
                    100%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-893">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-894">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-895">
                    -
                  </td>
                </tr>
                <tr data-id="element-896">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-897">
                    May 2023
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-898">
                    100%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-899">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-900">
                    -
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-901">
                    -
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-902">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-903">
          Growth Opportunities
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-904">
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4" data-id="element-905">
            <div className="flex items-center mb-3" data-id="element-906">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400" data-id="element-907">
                <TrendingUp size={20} data-id="element-908" />
              </div>
              <h4 className="ml-3 text-base font-medium text-blue-800 dark:text-blue-300" data-id="element-909">
                Premium Conversion
              </h4>
            </div>
            <p className="text-sm text-blue-700 dark:text-blue-400 mb-3" data-id="element-910">
              Only 18% of active users are on premium plans. Targeted promotions
              could increase this to 25%.
            </p>
            <div className="flex justify-between items-center" data-id="element-911">
              <div className="text-sm text-blue-700 dark:text-blue-400" data-id="element-912">
                <span className="font-bold" data-id="element-913">Potential Impact:</span>{' '}
                +$12,500/month
              </div>
              <button className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-300 rounded" data-id="element-914">
                View Strategy
              </button>
            </div>
          </div>
          <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4" data-id="element-915">
            <div className="flex items-center mb-3" data-id="element-916">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400" data-id="element-917">
                <TrendingUp size={20} data-id="element-918" />
              </div>
              <h4 className="ml-3 text-base font-medium text-green-800 dark:text-green-300" data-id="element-919">
                Referral Program
              </h4>
            </div>
            <p className="text-sm text-green-700 dark:text-green-400 mb-3" data-id="element-920">
              Implementing a user referral program could reduce CAC by 15% and
              increase organic growth.
            </p>
            <div className="flex justify-between items-center" data-id="element-921">
              <div className="text-sm text-green-700 dark:text-green-400" data-id="element-922">
                <span className="font-bold" data-id="element-923">Potential Impact:</span> +320
                users/month
              </div>
              <button className="text-xs px-2 py-1 bg-green-100 dark:bg-green-800 text-green-700 dark:text-green-300 rounded" data-id="element-924">
                View Strategy
              </button>
            </div>
          </div>
          <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-4" data-id="element-925">
            <div className="flex items-center mb-3" data-id="element-926">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-400" data-id="element-927">
                <TrendingUp size={20} data-id="element-928" />
              </div>
              <h4 className="ml-3 text-base font-medium text-purple-800 dark:text-purple-300" data-id="element-929">
                Investment Partners
              </h4>
            </div>
            <p className="text-sm text-purple-700 dark:text-purple-400 mb-3" data-id="element-930">
              Adding 3 new investment partners could increase platform revenue
              by 22% through referral commissions.
            </p>
            <div className="flex justify-between items-center" data-id="element-931">
              <div className="text-sm text-purple-700 dark:text-purple-400" data-id="element-932">
                <span className="font-bold" data-id="element-933">Potential Impact:</span>{' '}
                +$8,200/month
              </div>
              <button className="text-xs px-2 py-1 bg-purple-100 dark:bg-purple-800 text-purple-700 dark:text-purple-300 rounded" data-id="element-934">
                View Strategy
              </button>
            </div>
          </div>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-4" data-id="element-935">
            <div className="flex items-center mb-3" data-id="element-936">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-400" data-id="element-937">
                <TrendingUp size={20} data-id="element-938" />
              </div>
              <h4 className="ml-3 text-base font-medium text-yellow-800 dark:text-yellow-300" data-id="element-939">
                User Retention
              </h4>
            </div>
            <p className="text-sm text-yellow-700 dark:text-yellow-400 mb-3" data-id="element-940">
              Implementing an improved onboarding flow could increase 3-month
              retention by 15%.
            </p>
            <div className="flex justify-between items-center" data-id="element-941">
              <div className="text-sm text-yellow-700 dark:text-yellow-400" data-id="element-942">
                <span className="font-bold" data-id="element-943">Potential Impact:</span> +$15,400
                LTV
              </div>
              <button className="text-xs px-2 py-1 bg-yellow-100 dark:bg-yellow-800 text-yellow-700 dark:text-yellow-300 rounded" data-id="element-944">
                View Strategy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Business;